<template>
  <section class="my-8 md:mb-8 md:mt-8 font-arial mx-auto max-w-[1400px]">
    <section
      class="my-8 bg-black pt-6 px-2 md:px-10 pb-5 font-bold shadow-black shadow-xl"
    >
      <RallyLogoDownload link-text="Download Rally Navigator" />
      <div
        class="my-8 text-lg flex flex-col border-white border-t-2 border-b-2 divide-y-2 divide-white py-4"
      >
        <div>
          <h1 class="font-russo text-3xl text-white py-4">
            RALLY NAVIGATOR DEVELOPERS
          </h1>
          <ul class="flex flex-col gap-8 my-4 text-white text-left">
            <li>
              <DeveloperRow
                first-name="Mike"
                fullName="MIKE SHIRLEY"
                image="images/hi-res-mike.jpg"
                description="Mike is the primary developer of Rally Navigator. Mike had the vision to make rally route creation simpler and faster. Mike has been an RMS crew member at the Dakar Rally twice and has raced in Mongolia and Mexico. He&#8217;s also known to ironman the Vegas to Reno."
                ride-name="2018 Husqvarna FE501"
                contact-caption="Questions, Feedback or Discuss your Upcoming Rally Event"
                contact="mike@rallynavigator.com"
              />
            </li>
            <li>
              <DeveloperRow
                first-name="Dave"
                fullName="DAVE PECKHAM"
                image="images/hi-res-dave.jpg"
                description="Dave is a key contributor to Rally Navigator. His knowledge of software development and his expertise in Rally make him a perfect partner. He&#8217;s been on the US rally scene since 2007. Rally racing has taken Dave to 10 countries on 4 continents. He has raced the Rally Dos Sertoes and the Baja Rally and been Mechanic and Team Manager at the Dakar Rally, the Tuareg Rally, and SCORE Baja races."
                ride-name="Méca&#8217;System KTM 500 EXC"
                ride-link="http://www.rallymanagementservices.com/collections/rally-kits/products/2012-ktm-450-500-efi-rally-kit-evo-3-mecasystem"
              />
            </li>
            <li>
              <DeveloperRow
                first-name="Filipe"
                fullName="FILIPE GUERRA"
                image="images/hi-res-filipe.jpg"
                description="Filipe joined the Rally Navigator family in 2022. A software engineer at heart with a passion for Rally Raid, that's been riding Rallies in western europe, and training others to do so. He is also the developer of Terrapirata's digital roadbook app and platform, embracing the new digital era and pushing it's limits."
                ride-name="2019 KTM 690 R"
                ride-link="https://www.instagram.com/p/CtwdZmZIqEE/"
              />
            </li>
            <li>
              <DeveloperRow
                first-name="Sergei"
                fullName="SERGEI GRISHIN"
                image="images/hi-res-sergei.jpg"
                description="Sergei came on board in 2024. With a background in software and hardware product development and a passion for rallies, he was excited to join the Rally Navigator team. Sergei has competed and volunteered in Stage Rally and Rallycross events in the U.S. since 2015. When he&#8217;s not at a rally, he takes on product design and manufacturing projects at Bear Prototyping."
                ride-name="2016 Ford Fiesta ST"
                ride-link="https://racingrebel.com/ford-fiesta-st-rally-car-specs/"
              />
            </li>
          </ul>
        </div>
        <ReviewRow
          title="Baja Rally - Baja Mexico"
          :images="[
            'images/Reviews/thumb-1.jpg',
            'images/Reviews/thumb-2-2.jpg',
            'images/Reviews/thumb-3.jpg',
          ]"
          description="Rally Navigator is the foundation of the BAJA RALLY logistics plan. This valuable tool helps our events in two ways: It simplifies the route making process and allows our participants to create practice stages which prepares them for a more successful experience. Rally Navigator is the gateway to the rally revolution."
          reviewer="Scotty Breauxman - BAJA RALLY Creator"
        />
        <ReviewRow
          title="NORRA Mexican 500"
          :images="[
            'images/Reviews/thumb-1-1.jpg',
            'images/Reviews/thumb-2.jpg',
            'images/Reviews/thumb-3-2.jpg',
          ]"
          description="Rally Navigator software made road book creation and editing a breeze. It literally saved us many days of work and an extra trip down the course. We were able to deliver roll charts and road books on a super tight timeline when last minute storms forced late route changes."
          reviewer="Chris Wilson - Course Designer"
        />
        <ReviewRow
          title="Amageza Rally - South Africa"
          :images="[
            'images/Reviews/thumb-1-2.jpg',
            'images/Reviews/thumb-2-1.jpg',
            'images/Reviews/thumb-3-3.jpg',
          ]"
          description="Rally Navigator has taken the job of building a rally-roadbook from the stone age to the rocket age. Thanks to Mike Shirley and his team the Amageza Rallye will be racing from Cape Town in South Africa to the border with Namibia using road-books created on Rally Navigator. Great work guys!!"
          reviewer="Alexander Nel - Director"
        />
      </div>
    </section>
    <FeaturesBanner />
    <PartnersSmall />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
</template>

<script>
import DeveloperRow from './DeveloperRow.vue';
import FeaturesBanner from './FeaturesBanner.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import ReviewRow from './ReviewRow.vue';

export default {
  name: 'AboutPage',
  components: {
    FeaturesBanner,
    PartnersSmall,
    RallyLogoDownload,
    DeveloperRow,
    ReviewRow,
  },
};
</script>

<style scoped></style>
